module.exports = __webpack_public_path__ + "img/pic_1.5fdf06e7.jpg";